import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import { getMonedas } from 'api/configuracion';

// eslint-disable-next-line react/prop-types
const Monedas = ({ permission }) => (
  <PlainCRUD
    title="Monedas"
    permission={permission}
    get={getMonedas}
    fields={[
      defaultFields.clave,
      defaultFields.descripcion,
      {
        name: 'decimales',
        label: 'Decimales',
        type: 'decimal',
        colWidth: 150,
      },
    ]}
    readOnly
  />
);

export default Monedas;
